import script from "./ImportadorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportadorComponent.vue?vue&type=script&setup=true&lang=js"

import "./ImportadorComponent.vue?vue&type=style&index=0&id=737c2f8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-737c2f8a"]])

export default __exports__